import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import NonAppPageShell from "./NonAppPageShell";
export default function AgeSuitabilityPage(t0) {
  const $ = _c(28);
  const {
    transportDescription: t1,
    contactEmail: t2,
    origin: t3
  } = t0;
  const transportDescription = t1 === undefined ? "buses/trains" : t1;
  const contactEmail = t2 === undefined ? "feedback@catchy.nz" : t2;
  const origin = t3 === undefined ? "https://catchy.nz" : t3;
  const t4 = `${origin}/age-suitability`;
  const t5 = `${origin}/share/default-share-image.png`;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h1 className="mb-4 text-3xl font-semibold">Age suitability</h1>;
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  let t7;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <strong className="mb-2 block">At a glance</strong>;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mb-4 rounded bg-blue-400/20 px-4 pb-4 pt-3 text-base">{t7}<ul className="list-disc space-y-1 pl-5"><li>Age rating: 4+ (iOS), Everyone (Android)</li><li>Accounts: none needed</li><li>Tracking: none</li><li>Social features: none</li></ul></div>;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== transportDescription) {
    t9 = <div className="mb-4 flex flex-col gap-3">{t8}<p className="mb-2">Catchy is a public transport app that helps you check departures, view service updates, and follow {transportDescription} on live maps. It’s designed to be straightforward and safe for everyone, including kids.</p></div>;
    $[3] = transportDescription;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="mb-4">Catchy is rated:</p>;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ul className="mb-6 list-disc space-y-1 pl-5"><li><span className="font-semibold">Ages 4+</span> on the Apple App Store</li><li><span className="font-semibold">Everyone</span> on Google Play</li></ul>;
    t12 = <p className="mb-12">Catchy does not include social features like user posting, commenting, or in-app messaging.</p>;
    t13 = <h2 className="mb-2 text-xl font-semibold">App content</h2>;
    t14 = <p className="mb-4">Catchy shows public transport information such as:</p>;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
  } else {
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
  }
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ul className="mb-4 list-disc space-y-1 pl-5"><li>stop departures and timetables</li><li>cancellations and announcements</li><li>live trip maps and vehicle progress</li></ul>;
    t16 = <p className="mb-12">There’s no mature or user-generated content in Catchy.</p>;
    t17 = <h2 className="mb-2 text-xl font-semibold">Children travelling safely</h2>;
    t18 = <p className="mb-4">Catchy can help with navigation, but it can’t replace real-world travel safety. For younger users, we recommend using Catchy alongside a parent/caregiver’s guidance, especially for:</p>;
    $[10] = t15;
    $[11] = t16;
    $[12] = t17;
    $[13] = t18;
  } else {
    t15 = $[10];
    t16 = $[11];
    t17 = $[12];
    t18 = $[13];
  }
  let t19;
  let t20;
  let t21;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ul className="mb-12 list-disc space-y-1 pl-5"><li>crossing roads</li><li>travelling at night</li><li>making last-minute changes when services are disrupted</li></ul>;
    t20 = <h2 className="mb-2 text-xl font-semibold">Privacy and data</h2>;
    t21 = <p className="mb-4">Catchy is private by design:</p>;
    $[14] = t19;
    $[15] = t20;
    $[16] = t21;
  } else {
    t19 = $[14];
    t20 = $[15];
    t21 = $[16];
  }
  let t22;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ul className="mb-4 list-disc space-y-1 pl-5"><li>no login required to save favourites</li><li>no tracking of what you personally do in the app</li><li>no third-party trackers or cookies</li><li>no personal information stored by Catchy</li></ul>;
    $[17] = t22;
  } else {
    t22 = $[17];
  }
  let t23;
  let t24;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <p className="mb-12">For more details, read the{" "}<Link href="/privacy" className="text-blue-500">Privacy Policy</Link>.</p>;
    t24 = <h2 className="mb-2 text-xl font-semibold">Questions</h2>;
    $[18] = t23;
    $[19] = t24;
  } else {
    t23 = $[18];
    t24 = $[19];
  }
  const t25 = `mailto:${contactEmail}`;
  let t26;
  if ($[20] !== contactEmail || $[21] !== t25) {
    t26 = <p className="mb-6">If you have questions about age suitability or privacy, contact:{" "}<a href={t25} className="text-blue-500">{contactEmail}</a></p>;
    $[20] = contactEmail;
    $[21] = t25;
    $[22] = t26;
  } else {
    t26 = $[22];
  }
  let t27;
  if ($[23] !== t26 || $[24] !== t4 || $[25] !== t5 || $[26] !== t9) {
    t27 = <NonAppPageShell title={"Catchy \u2014 Age suitability"} description="Information about age suitability, privacy, and safety for Catchy users." canonicalUrl={t4} image={t5} twitterDescription="Is Catchy suitable for kids? Short overview and privacy notes." className="pb-10">{t6}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t26}</NonAppPageShell>;
    $[23] = t26;
    $[24] = t4;
    $[25] = t5;
    $[26] = t9;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  return t27;
}